import type { ReactNode } from "react";
import { cn } from "../../utils/cn";

export interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  /** Conteúdo extra abaixo do header (ex.: filter bar). */
  toolbar?: ReactNode;
  className?: string;
}

export function PageHeader({ title, subtitle, actions, toolbar, className }: PageHeaderProps) {
  return (
    <div className={cn("border-b border-border bg-topbar", className)}>
      <div className="px-6 py-5 flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h1 className="text-xl font-semibold text-foreground tracking-tight">{title}</h1>
          {subtitle && (
            <p className="text-sm text-muted-foreground mt-0.5">{subtitle}</p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
      </div>
      {toolbar && <div className="px-6 py-3 border-t border-border-subtle bg-surface-1">{toolbar}</div>}
    </div>
  );
}
